/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxProfessionalDoubleBurnerComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxProfessionalDoubleBurner').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'BURNER_DOUBLE_LYNX_PROFESSIONAL_LSB22',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-professional-double-burner.js.map